import React from 'react'
import Container from 'js/pages/LandingPages/components/Container'
import { pushToDataLayer } from 'js/pages/LandingPages/utils'
import { FeatureImageType } from 'js/components/FeatureImage'
import { SharedSectionProps } from './types'
import LSButton from 'js/components/LSButton'
import { APP_STORE_LINK } from '../content'
import Card from './Card'

type Props = {
  title: string
  features: {
    heading: string | null
    text: string | null
    image: { responsiveImage: FeatureImageType } | null
  }[]
  downloadLinkText: string
  onOpenModal: (flag: boolean) => void
} & SharedSectionProps

const HighlightedFeatures = ({
  title,
  features,
  downloadLinkText,
  onOpenModal,
}: Props) => {
  const handleOpenModal = () => {
    pushToDataLayer({
      event: 'click_event',
      click_type: 'button',
      click_text: downloadLinkText?.toLowerCase(),
      action: undefined,
      location: title.toLowerCase(),
    })

    onOpenModal(true)
  }

  return (
    <section className="pt-[52px] md:pt-96">
      <Container>
        <h2 className="quincy max-w-[620px] pb-32 text-left text-32 leading-37 lg:pb-56 lg:text-48 lg:leading-52">
          {title}
        </h2>
        <div className="grid gap-x-[40px] gap-y-[16px] pb-24 lg:grid-cols-3 lg:pb-32">
          {features.map((item) => (
            <Card
              key={item.heading}
              image={item.image?.responsiveImage as FeatureImageType}
              title={item.heading as string}
              description={item.text as string}
            />
          ))}
        </div>
        <LSButton
          link
          size="large"
          href={APP_STORE_LINK}
          variant="primary"
          upperCase
          onClick={() =>
            pushToDataLayer({
              event: 'click_event',
              click_type: 'button',
              click_text: 'download',
              action: undefined,
              location: title?.toLowerCase(),
            })
          }
          className="ml-0 block lg:hidden"
        >
          {downloadLinkText}
        </LSButton>
        <LSButton
          link={false}
          variant="primary"
          size="large"
          upperCase
          className="relative ml-0 hidden w-full py-[19px] md:w-auto lg:block lg:py-[14.5px]"
          onClick={handleOpenModal}
        >
          {downloadLinkText}
        </LSButton>
      </Container>
    </section>
  )
}

export default HighlightedFeatures
